import { Controller } from "@hotwired/stimulus"
import CSVBoxImporter from "@csvbox/csvboxjs"
import RequestHelper from "../helpers/request_helper.js"

export default class extends Controller {
  static get targets() {
    return ["deliveryMethod", "templateLink"]
  }

  connect() {
    this.updateTemplateLink();
  }

  changeDeliveryMethod() {
    this.updateTemplateLink();
  }

  // Points "Download template" at the template matching the selected delivery method,
  updateTemplateLink() {
    const deliveryMethod = this.deliveryMethodTarget.value;
    this.templateLinkTarget.closest(".template-download").classList.toggle("hidden", deliveryMethod === "gift_pool");
    this.templateLinkTarget.setAttribute(
      "href",
      this.templateLinkTarget.dataset[deliveryMethod === "link" ? "linkTemplate" : "emailTemplate"]
    );
  }

  open(event) {
    event.preventDefault();

    const deliveryMethod = this.deliveryMethodTarget.value || "email";
    if (deliveryMethod === "gift_pool") {
      window.location.href = this.deliveryMethodTarget.dataset.giftPoolUrl;
      return;
    }

    const data = event.currentTarget.dataset;
    this.lookupUrlTemplate = data.importLookupUrlTemplate;

    const importer = new CSVBoxImporter(data.csvboxLicenseKey, {}, (success, result) => {
      this.handleImportResult(success, result);
    });
    importer.setUser({
      user_id: data.userid,
      email: data.email,
      name: data.name,
      delivery_method: deliveryMethod,
      type: "bulk_gift_import"
    });
    importer.openModal();
  }

  // Rows are validated and the BulkGiftImport created server-side by
  // Hooks::CsvboxesController, which csvbox posts to directly
  handleImportResult(success, result) {
    if (!success || !result || !result.import_id) { return; }

    const url = this.lookupUrlTemplate.replace("EXTERNAL_IMPORT_ID", result.import_id);
    fetch(url, RequestHelper.defaultRequestOptions()).
      then(response => response.json()).
      then(json => {
        this.element.dispatchEvent(new CustomEvent("csvbox:imported", { detail: json, bubbles: true }));
      });
  }
}
